<script>
import MainOrderStatus from '~/marketplace-front-core/components/orders/status/Main'
import PaymentOrderStatus from '~/marketplace-front-core/components/orders/status/Payment'
import ShippingOrderStatus from '~/marketplace-front-core/components/orders/status/Shipping'

export default {
  components: { MainOrderStatus, PaymentOrderStatus, ShippingOrderStatus }
}
</script>
